import type { AreaCatalog } from '../area';
import type { lenses as en } from '../en/lenses';

export const lenses = {
  'lenses.index.title': 'Ansichten',
  'lenses.index.subEmpty': 'gespeicherte Blickwinkel',
  'lenses.index.saved': '{count} gespeichert',
  'lenses.index.favorites': 'Favoriten',
  'lenses.index.all': 'Alle Ansichten',
  'lenses.index.archived': 'Archiviert',
  'lenses.index.empty':
    'Eine Ansicht ist ein gespeicherter Filter mit einer Darstellung. Sie zeigt allen, was sie ohnehin sehen können.',
  'lenses.index.yours': 'von dir',

  'lenses.page.count': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  'lenses.surface.empty': 'Nichts, was du sehen kannst, passt zu dieser Ansicht.',
  'lenses.budget.shown': '{shown} von {total}',
  'lenses.budget.more': 'mehr',
  'lenses.budget.moreLabel': '{next} von {total} anzeigen',

  'lenses.archived': 'Archiviert',

  'lenses.tombstone.note':
    'Diese Ansicht wurde archiviert. Ihre Einstellungen bleiben lesbar. Zweig sie ab, um diesen Blickwinkel zu behalten.',
  'lenses.tombstone.criteria': 'Kriterien',
  'lenses.tombstone.noCriteria': 'keine, also alles, was du sehen kannst',
  'lenses.tombstone.defaultRail': 'Voreingestellte Darstellung',
  'lenses.tombstone.rail.list': 'Liste',
  'lenses.tombstone.rail.board': 'Kanban',
  'lenses.tombstone.rail.map': 'Landkarte',
  'lenses.tombstone.rail.checklist': 'Checkliste',
  'lenses.tombstone.fork': 'Diese Ansicht abzweigen',

  'lenses.rail.label': 'Darstellung',
  'lenses.rail.menu': 'Darstellung ({rail})',
  'lenses.rail.showAs': 'Anzeigen als',
  'lenses.rail.list': 'Liste',
  'lenses.rail.listTitle': 'Als Liste anzeigen',
  'lenses.rail.board': 'Kanban',
  'lenses.rail.boardTitle': 'Als Kanban anzeigen',
  'lenses.rail.map': 'Landkarte',
  'lenses.rail.mapTitle': 'Auf der Landkarte anzeigen',
  'lenses.rail.checklist': 'Checkliste',
  'lenses.rail.checklistTitle': 'Als Checkliste abhaken',

  'lenses.lanes.menu': 'Spalten nach',
  'lenses.lanes.assignee': 'Zuständig',
  'lenses.lanes.group': 'Gruppe',
  'lenses.lanes.unassigned': 'Noch zu vergeben',
  'lenses.lanes.ungrouped': 'Ohne Gruppe',

  'lenses.arrange.groupBy': 'Gruppieren nach',
  'lenses.arrange.sortBy': 'Sortieren nach',
  'lenses.arrange.orderManually': 'Von Hand ordnen…',
  'lenses.arrange.editCustomGroups': 'Eigene Abschnitte bearbeiten…',
  'lenses.arrange.customGroups': 'Eigene Abschnitte…',
  'lenses.arrange.hiddenGroups': 'Ausgeblendete Abschnitte',
  'lenses.sort.due': 'Fälligkeit',
  'lenses.sort.manual': 'Von Hand',

  'lenses.section.moveUp': 'Nach oben',
  'lenses.section.moveDown': 'Nach unten',
  'lenses.section.hide': 'Abschnitt ausblenden',
  'lenses.section.expandAll': 'Alle ausklappen',
  'lenses.section.collapseAll': 'Alle einklappen',
  'lenses.section.resetOrder': 'Reihenfolge zurücksetzen',

  'lenses.dialog.cancel': 'Abbrechen',
  'lenses.dialog.apply': 'Übernehmen',

  'lenses.order.title': 'Abschnitte ordnen',
  'lenses.order.loading': 'Abschnitte werden geladen…',
  'lenses.order.empty': 'Keine Abschnitte: Nichts in dieser Ansicht gehört zu einem.',
  'lenses.order.groups': 'Abschnitte',
  'lenses.order.move': '„{name}“ verschieben',
  'lenses.order.show': '„{name}“ anzeigen',
  'lenses.order.hide': '„{name}“ ausblenden',

  'lenses.customGroups.title': 'Eigene Abschnitte',
  'lenses.customGroups.note':
    'Eine Zeile steht unter jedem Abschnitt, dessen Kriterien sie erfüllt. Zeilen, die kein Abschnitt aufnimmt, kommen unter „Sonstige“.',
  'lenses.customGroups.tooLong':
    'Diese Abschnitte sind zu lang, um sie zu übernehmen. Kürze einen Namen oder entferne ein Kriterium.',
  'lenses.customGroups.nameMissing': 'Gib dem Abschnitt einen Namen.',
  'lenses.customGroups.add': 'Abschnitt hinzufügen',
  'lenses.customGroups.limit': {
    one: 'Eine Ansicht hat höchstens {count} Abschnitt.',
    other: 'Eine Ansicht hat höchstens {count} Abschnitte.',
  },
  'lenses.customGroups.name': 'Name',
  'lenses.customGroups.criteria': 'Kriterien',
  'lenses.customGroups.addCriteria': 'Kriterium hinzufügen…',
  'lenses.customGroups.move': '„{name}“ verschieben',
  'lenses.customGroups.moveUnnamed': 'Abschnitt ohne Namen verschieben',
  'lenses.customGroups.criteriaOf': 'Kriterien von „{name}“',
  'lenses.customGroups.criteriaOfUnnamed': 'Kriterien des Abschnitts ohne Namen',
  'lenses.customGroups.remove': '„{name}“ entfernen',
  'lenses.customGroups.removeUnnamed': 'Abschnitt ohne Namen entfernen',

  'lenses.configure.label': 'Ansicht einrichten',
  'lenses.configure.labelDirty': 'Ansicht einrichten (ungespeicherte Änderungen)',
  'lenses.configure.titleClean': 'Diese Ansicht einrichten: wie sie gespeichert und geteilt wird',
  'lenses.configure.titleDirty': 'Diese Ansicht einrichten: Sie hat ungespeicherte Änderungen',
  'lenses.configure.subtitleDirty': 'Diese Ansicht hat ungespeicherte Änderungen',
  'lenses.configure.unsaved': 'Ungespeicherte Änderungen',
  'lenses.configure.unsavedNote':
    'Dein Filter und deine Anordnung gelten hier, sind aber nicht gespeichert. Behalte sie für alle, die diese Ansicht öffnen, oder nimm sie in eine eigene Ansicht mit.',
  'lenses.configure.nothingToSave':
    'Nichts zu speichern: Die Ansicht ist so, wie sie gespeichert wurde. Ändere Filter oder Anordnung, dann landen die Änderungen hier.',
  'lenses.configure.update': 'Ansicht aktualisieren',
  'lenses.configure.fork': 'Abzweigen',
  'lenses.configure.saveAsLens': 'Als Ansicht speichern',
  'lenses.configure.standard': 'Standard',
  'lenses.configure.deviates':
    'Deine Seite „Aufgaben“ ist eigens eingerichtet und weicht von {standard} ab. Wiederherstellen setzt sie auf diesen Standard zurück. Du kannst sie danach jederzeit wieder anpassen.',
  'lenses.configure.follows':
    'Deine Seite „Aufgaben“ folgt {standard}. Ändere Filter oder Anordnung und speichere, dann wird sie zu deiner eigenen.',
  'lenses.configure.restore': 'Standard wiederherstellen',
  'lenses.configure.work': 'Aufgaben',
  'lenses.configure.adoptNote':
    'Deine Seite „Aufgaben“ übernimmt eine Kopie des gespeicherten Filters und der Anordnung dieser Ansicht.',
  'lenses.configure.adoptCopy':
    'Spätere Änderungen an dieser Ansicht ändern deine Seite „Aufgaben“ nicht.',
  'lenses.configure.adopt': 'In „Aufgaben“ übernehmen',
  'lenses.configure.view': 'Ansicht',
  'lenses.configure.name': 'Name',
  'lenses.configure.defaultLayout': 'Voreingestellte Darstellung',
  'lenses.configure.archive': 'Diese Ansicht archivieren',
  'lenses.configure.leave': 'Diese Ansicht verlassen',
  'lenses.configure.restoreView': 'Diese Ansicht wiederherstellen',

  'lenses.standardMark.label': 'Eigene',
  'lenses.standardMark.title':
    'Weicht vom Standard {standard} ab. „Ansicht einrichten“ stellt ihn wieder her.',
} as const satisfies AreaCatalog<typeof en>;
